// extracted by css-extract-rspack-plugin
export default {"list":"list-EIRBgp","fee-row":"fee-row-BXdh12","feeRow":"fee-row-BXdh12","fee-delete":"fee-delete-oGbx03","feeDelete":"fee-delete-oGbx03"};